export interface CampanhaOptionsActions {
    canEdit: boolean;
    canVisualizar: boolean;
    canDelete: boolean;
    // Análise
    canSolicitarAnalise: boolean;
    canAprovarAnalise: boolean;
    canReprovarAnalise: boolean;
    // Encerramento
    canEncerrar: boolean;
    // Pedidos
    canLiberarPedidos: boolean;
}

export class CampanhaOptions implements CampanhaOptionsActions {
    canEdit: boolean;
    canVisualizar: boolean;
    canDelete: boolean;
    // Análise
    canSolicitarAnalise: boolean;
    canAprovarAnalise: boolean;
    canReprovarAnalise: boolean;
    // Encerramento
    canEncerrar: boolean;
    // Pedidos
    canLiberarPedidos: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canEdit ||
            this.canVisualizar ||
            this.canDelete ||
            this.hasAnyOptionAnalise() ||
            this.hasAnyOptionPedido();
    }

    /** Verifica se possui alguma opção da análise habilitada */
    hasAnyOptionAnalise(): boolean {
        return this.canSolicitarAnalise ||
                this.canAprovarAnalise ||
                this.canReprovarAnalise;
    }

    /** Verifica se possui alguma opção de encerramento habilitada */
    hasAnyOptionEncerramento(): boolean {
        return this.canEncerrar;
    }

    /** Verifica se possui alguma opção de pedidos habilitada */
    hasAnyOptionPedido(): boolean {
        return this.canLiberarPedidos;
    }
}
